export default __webpack_public_path__ + "static/media/A3_mercado_neg.b3e8b21d.svg";